/*
 * ========================================
 * カート情報取得
 * ========================================
 */
async function getCart() {
  const response = await fetch(
    `${window.Shopify.routes.root}cart.js`
  );

  if (!response.ok) {
    throw new Error('カート情報を取得できませんでした。');
  }

  return await response.json();
}


/*
 * ========================================
 * 一般 / 卸 モードをブラウザに記憶
 * ========================================
 */
async function updateCartMode() {
  const state =
    document.querySelector('#wholesale-cart-state');

  if (!state) return;

  const hasWholesale =
    state.dataset.hasWholesale === 'true';

  const cartEmpty =
    state.dataset.cartEmpty === 'true';

  const leafletVariantId =
    Number(state.dataset.leafletVariantId);

  /*
   * カートが空の場合は
   * 直前のモードをそのまま維持
   */
  if (cartEmpty) {
    return;
  }

  /*
   * 卸商品がある場合は
   * 必ず卸モード
   */
  if (hasWholesale) {
    sessionStorage.setItem(
      'cartMode',
      'wholesale'
    );

    return;
  }

  /*
   * 卸商品がなくても
   * リーフレットが残っている場合は
   * 卸モードを維持
   */
  if (leafletVariantId) {
    try {
      const cart = await getCart();

      const hasLeaflet =
        cart.items.some(
          item =>
            item.variant_id === leafletVariantId
        );

      if (hasLeaflet) {
        sessionStorage.setItem(
          'cartMode',
          'wholesale'
        );

        return;
      }

    } catch (error) {
      console.error(
        'Cart mode update error:',
        error
      );
    }
  }

  /*
   * 卸商品でもリーフレットでもない場合は
   * 一般モード
   */
  sessionStorage.setItem(
    'cartMode',
    'general'
  );
}


/*
 * ========================================
 * 「買い物を続ける」リンク切替
 * ========================================
 */
function updateContinueShoppingLinks() {
  const links = document.querySelectorAll(
    '[data-continue-shopping]'
  );

  if (!links.length) return;

  const cartMode =
    sessionStorage.getItem('cartMode');

  /*
   * 一般商品の戻り先
   */
  const generalUrl = '/collections/frontpage';

  /*
   * 卸商品の戻り先
   */
  const wholesaleUrl = '/pages/wholesale';

  links.forEach((link) => {
    if (cartMode === 'wholesale') {
      link.href = wholesaleUrl;
    } else {
      link.href = generalUrl;
    }
  });
}


/*
 * ========================================
 * リーフレットのみの場合
 * 注文ボタンを無効化
 * ========================================
 */
async function updateLeafletCheckoutState() {
  const state =
    document.querySelector('#wholesale-cart-state');

  const checkoutButton =
    document.querySelector('#checkout');

  if (!state || !checkoutButton) return;

  const leafletVariantId =
    Number(state.dataset.leafletVariantId);

  if (!leafletVariantId) return;

  try {
    const cart = await getCart();

    /*
     * カートに商品があり、
     * すべての商品がリーフレットなら true
     */
    const leafletOnly =
      cart.items.length > 0 &&
      cart.items.every(
        item => item.variant_id === leafletVariantId
      );

    /*
     * 通常の「ご購入手続き」ボタン
     */
    checkoutButton.disabled = leafletOnly;

    /*
     * 注意文
     */
    let warning =
      document.querySelector(
        '.cart__leaflet-warning'
      );

    if (leafletOnly) {
      if (!warning) {
        warning =
          document.createElement('p');

        warning.className =
          'cart__leaflet-warning';

        warning.textContent =
          '※リーフレットのみではご注文いただけません。卸商品とあわせてご注文ください。';

        checkoutButton.insertAdjacentElement(
          'afterend',
          warning
        );
      }
    } else {
      if (warning) {
        warning.remove();
      }
    }

    /*
     * Shop Pay / Google Payなどの
     * 高速チェックアウト
     */
    const dynamicCheckout =
      document.querySelector(
        '.cart__dynamic-checkout-buttons'
      );

    if (dynamicCheckout) {
      dynamicCheckout.style.display =
        leafletOnly ? 'none' : '';
    }

  } catch (error) {
    console.error(
      'Checkout state error:',
      error
    );
  }
}


/*
 * ========================================
 * リーフレット追加ボタン
 * ========================================
 */
function initLeafletButton() {
  const state =
    document.querySelector('#wholesale-cart-state');

  const button =
    document.querySelector('#add-leaflet');

  const quantitySelect =
    document.querySelector('#leaflet-quantity');

  const message =
    document.querySelector('#leaflet-message');

  /*
   * 卸商品がない場合など、
   * リーフレットUIが存在しなければ終了
   */
  if (
    !state ||
    !button ||
    !quantitySelect
  ) {
    return;
  }

  /*
   * AJAX更新後のイベント二重登録防止
   */
  if (button.dataset.initialized === 'true') {
    return;
  }

  button.dataset.initialized = 'true';

  const variantId =
    Number(state.dataset.leafletVariantId);

  if (!variantId) {
    return;
  }


  /*
   * ========================================
   * リーフレット追加ボタンクリック
   * ========================================
   */
  button.addEventListener('click', async () => {

    const addQuantity =
      Number(quantitySelect.value);

    const maxQuantity = 100;

    /*
     * 数量チェック
     */
    if (
      !addQuantity ||
      addQuantity < 1 ||
      addQuantity > maxQuantity
    ) {
      if (message) {
        message.textContent =
          '1〜100冊の範囲で選択してください。';
      }

      return;
    }

    button.disabled = true;

    try {

      /*
       * 現在のカートを取得
       */
      const cart = await getCart();


      /*
       * 現在カートに入っている
       * リーフレットを探す
       */
      const leafletItem = cart.items.find(
        item => item.variant_id === variantId
      );


      /*
       * 現在のリーフレット冊数
       */
      const currentQuantity =
        leafletItem
          ? leafletItem.quantity
          : 0;


      /*
       * 追加後の合計
       */
      const totalQuantity =
        currentQuantity + addQuantity;


      /*
       * ========================================
       * 最大100冊チェック
       * ========================================
       */
      if (totalQuantity > maxQuantity) {

        const remainingQuantity =
          maxQuantity - currentQuantity;

        if (message) {

          if (remainingQuantity <= 0) {

            message.textContent =
              'リーフレットは1注文につき最大100冊までです。';

          } else {

            message.textContent =
              `現在${currentQuantity}冊入っています。あと${remainingQuantity}冊まで追加できます。`;

          }
        }

        return;
      }


      /*
       * ========================================
       * リーフレット追加
       * ========================================
       */
      const response = await fetch(
        `${window.Shopify.routes.root}cart/add.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: addQuantity
              }
            ]
          })
        }
      );


      const data = await response.json();


      if (!response.ok) {
        throw new Error(
          data.description ||
          data.message ||
          'リーフレットを追加できませんでした。'
        );
      }


      if (message) {
        message.textContent =
          `リーフレットを${addQuantity}冊追加しました。`;
      }


      /*
       * カート表示更新
       */
      window.location.reload();


    } catch (error) {

      console.error(
        'Leaflet add error:',
        error
      );


      if (message) {
        message.textContent =
          `エラー：${error.message}`;
      }


    } finally {
      button.disabled = false;
    }

  });
}


/*
 * ========================================
 * Dawnのカート更新後
 * ========================================
 */
async function handleLeafletCartUpdate() {

  /*
   * DawnによるDOM更新完了を少し待つ
   */
  await new Promise(resolve =>
    setTimeout(resolve, 150)
  );


  /*
   * 一般 / 卸モードを更新
   */
  await updateCartMode();


  /*
   * 「買い物を続ける」のリンク更新
   */
  updateContinueShoppingLinks();


  /*
   * リーフレットのみか再判定
   */
  await updateLeafletCheckoutState();


  /*
   * AJAX更新によって
   * リーフレットボタンが新しくなった場合に再登録
   */
  initLeafletButton();
}


/*
 * ========================================
 * 初回ページ読み込み
 * ========================================
 */
document.addEventListener(
  'DOMContentLoaded',
  async () => {

    /*
     * ========================================
     * 一般 / 卸モード記憶
     * ========================================
     */
    await updateCartMode();


    /*
     * ========================================
     * 「買い物を続ける」リンク設定
     * ========================================
     */
    updateContinueShoppingLinks();


    /*
     * ========================================
     * リーフレットのみか判定
     * ========================================
     */
    await updateLeafletCheckoutState();


    /*
     * ========================================
     * リーフレット追加ボタン初期化
     * ========================================
     */
    initLeafletButton();


    /*
     * ========================================
     * Dawnのカート更新イベントを監視
     * ========================================
     */
    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.cartUpdate
    ) {

      subscribe(
        PUB_SUB_EVENTS.cartUpdate,
        async () => {

          await handleLeafletCartUpdate();

        }
      );

    }


    /*
     * ========================================
     * カートDOM変更も監視
     * DawnのAJAX更新を取りこぼさないため
     * ========================================
     */
    const cartContainer =
      document.querySelector('#main-cart-items');

    if (cartContainer) {

      let leafletUpdateTimer;

      const observer =
        new MutationObserver(() => {

          /*
           * DOM更新が連続するため
           * 少し待ってから再判定
           */
          clearTimeout(leafletUpdateTimer);

          leafletUpdateTimer =
            setTimeout(async () => {

              /*
               * リーフレットのみか再判定
               */
              await updateLeafletCheckoutState();


              /*
               * 一般 / 卸モードも更新
               */
              await updateCartMode();


              /*
               * 「買い物を続ける」リンクも更新
               */
              updateContinueShoppingLinks();


              /*
               * AJAX更新後にボタンが作り直された場合
               * 再度イベント登録
               */
              initLeafletButton();

            }, 250);

        });


      observer.observe(
        cartContainer,
        {
          childList: true,
          subtree: true
        }
      );

    }

  }
);